export enum ImpactLevel {
  high = 'High',
  medium = 'Medium',
  low = 'Low',
}

export const ImpactLevelMap = {
  [ImpactLevel.high]: 'High Impact',
  [ImpactLevel.medium]: 'Medium Impact',
  [ImpactLevel.low]: 'Low Impact',
};
